export const initialise = () => {
    const layout = document.querySelector<HTMLBodyElement>('.layout-blogs')
    if (!layout) return
    addFiltersButtons(layout)
    filters(layout)
}

const addFiltersButtons = (layout: HTMLBodyElement) => {
    const container = layout.querySelector<HTMLElement>('.layout-blogs__container-filters .container-col')
    if (!container) return

    const group: HTMLDivElement = document.createElement('div')
    group.classList.add('layout-blogs__container-filters-buttons')

    const clear: HTMLAnchorElement = document.createElement('a')
    clear.classList.add('layout-blogs__container-filters-button-clear')
    clear.innerText = '{{js.layout-blogs.filters.button.clear.content}}'
    clear.ariaLabel = '{{js.layout-blogs.filters.button.clear.aria-label}}'
    clear.href = '{{js.layout-blogs.filters.button.clear.link}}'

    group.appendChild(clear)
    container.appendChild(group)
}

const filters = (layout: HTMLBodyElement) => {
    const filters = layout.querySelectorAll<HTMLElement>('.attrax-post-filters, .content-types-widget')

    filters.forEach((filter) => {
        const heading = filter.querySelector<HTMLHeadingElement>('.attrax-post-filters__heading-container, .content-types-widget__heading')
        if (!heading) return

        const button = document.createElement('button')
        button.classList.add('layout-blogs__container-filter-button')
        button.innerText = heading.innerText
        button.setAttribute('aria-expanded', 'false')

        filter.insertAdjacentElement('afterbegin', button)
        heading.remove()

        button.addEventListener('click', function(event: Event) {
            document.addEventListener('click', function clickAway(event: Event) {
                const target: HTMLElement = event.target as HTMLElement
                if (!filter.contains(target)) { 
                    button.setAttribute('aria-expanded', 'false')
                    document.removeEventListener('click', clickAway)
                }
            })

            filter.addEventListener('focusout', function tabAway(event: FocusEvent) {
                const target: HTMLElement = event.relatedTarget as HTMLElement
                if (!filter.contains(target)) {
                    button.setAttribute('aria-expanded', 'false')
                    filter.removeEventListener('focusout', tabAway)
                }
            })

            const expanded = button.getAttribute('aria-expanded')
            button.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true')
        })
    })
}